import { render, staticRenderFns } from "./BrandCard.vue?vue&type=template&id=26067cbd"
import script from "./BrandCard.vue?vue&type=script&lang=ts"
export * from "./BrandCard.vue?vue&type=script&lang=ts"
import style0 from "./BrandCard.vue?vue&type=style&index=0&id=26067cbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports